export class AzureEntraIdResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userCount",
            "baseName": "userCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "groupCount",
            "baseName": "groupCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "roleCount",
            "baseName": "roleCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "roleAssignmentCount",
            "baseName": "roleAssignmentCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "licenseCount",
            "baseName": "licenseCount",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return AzureEntraIdResource.attributeTypeMap;
    }
    constructor() {
    }
}
